<template>
  <v-text-field
    :label="label"
    :rules="rules"
    :placeholder="placeholder"
    :outlined="outlined"
    :dense="dense"
    :readonly="readonly"
    :value="formattedValue"
    @input="onInput"
    ref="inputField"
  />
</template>

<script>
export default {
  name: "CurrencyInput",
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    label: String,
    rules: Array,
    placeholder: String,
    outlined: { type: Boolean, default: true },
    dense: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
  },
  computed: {
    formattedValue() {
      const number = Math.round(Number(this.value) || 0);
      return "Rp " + number.toLocaleString("id-ID");
    },
  },
  methods: {
    onInput(val) {
      const numeric = parseInt((val || "").toString().replace(/\D/g, "")) || 0;
      this.$emit("input", numeric);
      this.$nextTick(() => {
        const input = this.$refs.inputField?.$el?.querySelector("input");
        if (input) {
          input.setSelectionRange(input.value.length, input.value.length);
        }
      });
    },
  },
};
</script>
